export const CLASSIC_DATE_PICKER_ERRORS = Object.freeze({
  invalidDate: "התאריך אינו תקין"
});
